/** Límites de cantidad en recetas (ingredientes y salida). Alineado con decimal(16,8) en BD. */
export const RECETA_MAX_DEC_DIGITS = 8;
export const RECETA_QTY_DECIMAL_FACTOR = 10 ** RECETA_MAX_DEC_DIGITS;
export const RECETA_QTY_MIN = 1 / RECETA_QTY_DECIMAL_FACTOR;
export const RECETA_QTY_MAX = 99_999_999.99999999;

/** Salida estándar de la receta (p. ej. 8000 ml). Mínimo 1 si no está definida. */
export function parseRecetaOutputQuantity(receta) {
  const raw = receta?.output_quantity ?? 1;
  const n = parseFloat(String(raw).replace(',', '.'));
  return Number.isFinite(n) && n > 0 ? n : 1;
}

/**
 * Factor de escalado: cantidad elaborada ÷ salida estándar.
 * Ej.: receta para 8000 ml y el usuario elabora 1 ml → factor = 1/8000.
 */
export function recetaScaleFactor(receta, cantidadElaborada) {
  const qty = Math.max(0, Number(cantidadElaborada) || 0);
  const outputQty = parseRecetaOutputQuantity(receta);
  return outputQty > 0 ? qty / outputQty : 0;
}
